@if (patientList0()) {
  <table>
    <thead>
      <tr>
        <th tuiTh rowspan="2">Patient</th>
        <th tuiTh rowspan="2">Date de naissance</th>
        <th tuiTh rowspan="2">Date d'installation</th>
        @if (dosActiviteList.includes("PPC")) {
          <th tuiTh colspan="5">Données</th>
        } @else if (dosActiviteList.includes("O2COV")) {
          <th tuiTh colspan="5">Données</th>
        } @else if (dosActiviteList.includes("OHD")) {
          <th tuiTh colspan="6">Données</th>
        } @else if (dosActiviteList.includes("O2PPC")) {
          <th tuiTh colspan="5">Données</th>
        } @else if (dosActiviteList.includes("O2VNI")) {
          <th tuiTh colspan="8">Données</th>
        } @else if (dosActiviteList.includes("O2 AV")) {
          <th tuiTh colspan="4">Données</th>
        }
        <th tuiTh rowspan="2">Dernier commentaire</th>
        <th tuiTh rowspan="2">Prescription valable jusqu'au</th>
        <th tuiTh rowspan="2" class="signature-en-masse">
          @if (dosActiviteList.includes("PPC")) {
            <button
              id="signer-masse-bouton"
              [disabled]="etatPush == 'loading'"
              type="button"
              iconStart="@tui.signature"
              size="s"
              tuiButton
              (click)="submit()"
            >
              Signer en masse
            </button>
          }
        </th>
      </tr>
      <tr>
        @if (
          dosActiviteList.includes("PPC") ||
          dosActiviteList.includes("O2PPC") ||
          dosActiviteList.includes("OHD") ||
          dosActiviteList.includes("O2VNI")
        ) {
          <th tuiTh>IAHI</th>
        }

        @if (dosActiviteList.includes("O2COV")) {
          <th tuiTh>Traitement</th>
        }

        @if (dosActiviteList.includes("O2COV")) {
          <th tuiTh>Déamb</th>
        }

        @if (
          dosActiviteList.includes("PPC") ||
          dosActiviteList.includes("O2PPC") ||
          dosActiviteList.includes("O2COV") ||
          dosActiviteList.includes("OHD") ||
          dosActiviteList.includes("O2VNI")
        ) {
          <th tuiTh>OBS</th>
        }

        @if (
          dosActiviteList.includes("PPC") ||
          dosActiviteList.includes("OHD") ||
          dosActiviteList.includes("O2PPC") ||
          dosActiviteList.includes("O2VNI")
        ) {
          <th tuiTh>IAHR</th>
        }

        @if (
          dosActiviteList.includes("PPC") || dosActiviteList.includes("O2PPC")
        ) {
          <th tuiTh>Fuites</th>
        }

        @if (
          dosActiviteList.includes("PPC") || dosActiviteList.includes("O2PPC")
        ) {
          <th tuiTh>P90/95</th>
        }

        @if (
          dosActiviteList.includes("O2COV") || dosActiviteList.includes("O2VNI")
        ) {
          <th tuiTh>Débit (R-E)</th>
        }

        @if (
          dosActiviteList.includes("O2COV") || dosActiviteList.includes("O2VNI")
        ) {
          <th tuiTh>Durée</th>
        }

        @if (
          dosActiviteList.includes("OHD") || dosActiviteList.includes("O2VNI")
        ) {
          <th tuiTh>Fuites méd.</th>
        }

        @if (
          dosActiviteList.includes("OHD") || dosActiviteList.includes("O2VNI")
        ) {
          <th tuiTh>Volume courant méd.</th>
        }

        @if (
          dosActiviteList.includes("OHD") || dosActiviteList.includes("O2VNI")
        ) {
          <th tuiTh>Fréquence respiratoire méd.</th>
        }

        @if (dosActiviteList.includes("O2 AV")) {
          <th tuiTh>Débit min</th>
        }

        @if (dosActiviteList.includes("O2 AV")) {
          <th tuiTh>Débit max</th>
        }

        @if (dosActiviteList.includes("O2 AV")) {
          <th tuiTh>Durée min</th>
        }

        @if (dosActiviteList.includes("O2 AV")) {
          <th tuiTh>Durée max</th>
        }
      </tr>
    </thead>
    <tbody>
      @for (patient of patientList0()!.data; track patient.id) {
        @for (activite of patient.activiteList; track $index) {
          @if (
            dosActiviteList.length === 0 || dosActiviteList.includes(activite)
          ) {
            <app-patient-row
              tuiTr
              [activite]="activite"
              [patient]="patient"
              [dosActiviteList]="dosActiviteList"
              (onClickSignMass)="clickSignMass(patient.id)"
              [signMass]="ppcOrdonnanceSignMass.includes(patient.id)"
              [libelleActivite]="
                (patient.activiteList && patient.activiteList!.length > 1) ??
                false
              "
            />
          }
        }
      }
    </tbody>
  </table>
  <tui-pagination
    [activePadding]="3"
    [index]="patientList0()!.currentPage ? patientList0()!.currentPage! - 1 : 0"
    [length]="patientList0()!.lastPage ?? 1"
    (indexChange)="changementDePage($event)"
  />
} @else {
  <table>
    <thead>
      <tr>
        <th tuiTh rowspan="2">Patient</th>
        <th tuiTh rowspan="2">Date de naissance</th>
        <th tuiTh rowspan="2">Date d'installation</th>
        @if (dosActiviteList.includes("PPC")) {
          <th tuiTh colspan="5">Données</th>
        } @else if (dosActiviteList.includes("O2COV")) {
          <th tuiTh colspan="5">Données</th>
        } @else if (dosActiviteList.includes("OHD")) {
          <th tuiTh colspan="6">Données</th>
        } @else if (dosActiviteList.includes("O2PPC")) {
          <th tuiTh colspan="5">Données</th>
        } @else if (dosActiviteList.includes("O2VNI")) {
          <th tuiTh colspan="8">Données</th>
        } @else if (dosActiviteList.includes("O2 AV")) {
          <th tuiTh colspan="4">Données</th>
        }
        <th tuiTh rowspan="2">Dernier commentaire</th>
        <th tuiTh rowspan="2">Prescription valable jusqu'au</th>
        <th tuiTh rowspan="2" class="signature-en-masse">
          @if (dosActiviteList.includes("PPC")) {
            @if (authService.getUser()?.role?.slug == "liberal") {
              <button
                id="signer-masse-bouton"
                [disabled]="etatPush == 'loading'"
                type="button"
                iconStart="@tui.signature"
                size="s"
                tuiButton
                (click)="submit()"
              >
                Signer en masse
              </button>
            }
          }
        </th>
      </tr>
      <tr>
        @if (
          dosActiviteList.includes("PPC") ||
          dosActiviteList.includes("O2PPC") ||
          dosActiviteList.includes("OHD") ||
          dosActiviteList.includes("O2VNI")
        ) {
          <th tuiTh>IAHI</th>
        }

        @if (dosActiviteList.includes("O2COV")) {
          <th tuiTh>Traitement</th>
        }

        @if (dosActiviteList.includes("O2COV")) {
          <th tuiTh>Déamb</th>
        }

        @if (
          dosActiviteList.includes("PPC") ||
          dosActiviteList.includes("O2PPC") ||
          dosActiviteList.includes("O2COV") ||
          dosActiviteList.includes("OHD") ||
          dosActiviteList.includes("O2VNI")
        ) {
          <th tuiTh>OBS</th>
        }

        @if (
          dosActiviteList.includes("PPC") ||
          dosActiviteList.includes("OHD") ||
          dosActiviteList.includes("O2PPC") ||
          dosActiviteList.includes("O2VNI")
        ) {
          <th tuiTh>IAHR</th>
        }

        @if (
          dosActiviteList.includes("PPC") || dosActiviteList.includes("O2PPC")
        ) {
          <th tuiTh>Fuites</th>
        }

        @if (
          dosActiviteList.includes("PPC") || dosActiviteList.includes("O2PPC")
        ) {
          <th tuiTh>P90/95</th>
        }

        @if (
          dosActiviteList.includes("O2COV") || dosActiviteList.includes("O2VNI")
        ) {
          <th tuiTh>Débit (R-E)</th>
        }

        @if (
          dosActiviteList.includes("O2COV") || dosActiviteList.includes("O2VNI")
        ) {
          <th tuiTh>Durée</th>
        }

        @if (
          dosActiviteList.includes("OHD") || dosActiviteList.includes("O2VNI")
        ) {
          <th tuiTh>Fuites méd.</th>
        }

        @if (
          dosActiviteList.includes("OHD") || dosActiviteList.includes("O2VNI")
        ) {
          <th tuiTh>Volume courant méd.</th>
        }

        @if (
          dosActiviteList.includes("OHD") || dosActiviteList.includes("O2VNI")
        ) {
          <th tuiTh>Fréquence respiratoire méd.</th>
        }

        @if (dosActiviteList.includes("O2 AV")) {
          <th tuiTh>Débit min</th>
        }

        @if (dosActiviteList.includes("O2 AV")) {
          <th tuiTh>Débit max</th>
        }

        @if (dosActiviteList.includes("O2 AV")) {
          <th tuiTh>Durée min</th>
        }

        @if (dosActiviteList.includes("O2 AV")) {
          <th tuiTh>Durée max</th>
        }
      </tr>
    </thead>
    <tbody>
      <app-patient-row
        tuiTr
        [patient]="undefined"
        [dosActiviteList]="dosActiviteList"
        class="placeholder"
      />
      <app-patient-row
        tuiTr
        [patient]="undefined"
        [dosActiviteList]="dosActiviteList"
        class="placeholder"
      />
      <app-patient-row
        tuiTr
        [patient]="undefined"
        [dosActiviteList]="dosActiviteList"
        class="placeholder"
      />
      <app-patient-row
        tuiTr
        [patient]="undefined"
        [dosActiviteList]="dosActiviteList"
        class="placeholder"
      />
      <app-patient-row
        tuiTr
        [patient]="undefined"
        [dosActiviteList]="dosActiviteList"
        class="placeholder"
      />

      <app-patient-row
        tuiTr
        [patient]="undefined"
        [dosActiviteList]="dosActiviteList"
        class="placeholder"
      />
      <app-patient-row
        tuiTr
        [patient]="undefined"
        [dosActiviteList]="dosActiviteList"
        class="placeholder"
      />
      <app-patient-row
        tuiTr
        [patient]="undefined"
        [dosActiviteList]="dosActiviteList"
        class="placeholder"
      />
      <app-patient-row
        tuiTr
        [patient]="undefined"
        [dosActiviteList]="dosActiviteList"
        class="placeholder"
      />
      <app-patient-row
        tuiTr
        [patient]="undefined"
        [dosActiviteList]="dosActiviteList"
        class="placeholder"
      />

      <app-patient-row
        tuiTr
        [patient]="undefined"
        [dosActiviteList]="dosActiviteList"
        class="placeholder"
      />
      <app-patient-row
        tuiTr
        [patient]="undefined"
        [dosActiviteList]="dosActiviteList"
        class="placeholder"
      />
      <app-patient-row
        tuiTr
        [patient]="undefined"
        [dosActiviteList]="dosActiviteList"
        class="placeholder"
      />
      <app-patient-row
        tuiTr
        [patient]="undefined"
        [dosActiviteList]="dosActiviteList"
        class="placeholder"
      />
      <app-patient-row
        tuiTr
        [patient]="undefined"
        [dosActiviteList]="dosActiviteList"
        class="placeholder"
      />
    </tbody>
  </table>
}
